import React, { createContext, useState, useEffect } from "react";

const DeviceContext = createContext({
  isMobileDevice: false,
  width: 1440,
});

const DeviceProvider = ({ children }) => {
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  const [width, setWidth] = useState(1440);

  const checkScreenWidth = () => {
    const currentWidth = document.body.clientWidth;
    setIsMobileDevice(currentWidth < 1240);
    setWidth(currentWidth);
  };

  useEffect(() => {
    checkScreenWidth();
    window.addEventListener("resize", checkScreenWidth);
    return () => {
      window.removeEventListener("resize", checkScreenWidth);
    };
  }, []);

  return (
    <DeviceContext.Provider value={{ isMobileDevice, width }}>
      {children}
    </DeviceContext.Provider>
  );
};

export { DeviceContext, DeviceProvider };
